import { React, useState } from 'react'
import { Form } from 'react-bootstrap';
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { ErrorMessage } from 'formik';

export default function PassField(props) {
    const [isHidden, setHidden] = useState(true);
    
  return (
    <div className='icon-field'>
        <Form.Label>Password</Form.Label>
        <Form.Control 
            type={isHidden ? 'password' : 'text'}  
            placeholder={props.placeholder}
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            disabled={props.isSubmitting}
        />
        <ErrorMessage name={props.name} component='p' className='error-message' />
            { isHidden
                ? <AiOutlineEyeInvisible size={25} className='icon-btn form-text' onClick={() => setHidden(!isHidden)} />
                : <AiOutlineEye size={25} color='#ED008C' className='icon-btn form-text' onClick={() => setHidden(!isHidden)} />
            }
    </div>
  )
}
